import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { formatAwsDateString } from "@covertree/utils/time/formatAwsDateString";
import { Resident } from "@graphql/api";
import { formatCurrency } from "@covertree/utils";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}

export default function LeaseDetails({ isLoading, resident }: Props) {
  return (
    <DisplayPropertiesCard
      properties={[
        {
          label: "Lease Start Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.lease?.startDate
                  ? formatAwsDateString(resident.lease.startDate)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Lease End Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.lease?.endDate
                  ? formatAwsDateString(resident.lease.endDate)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Lease Addendum Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.lease?.addendumDate
                  ? formatAwsDateString(resident.lease.addendumDate)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        ...(resident?.lease?.description
          ? [
              {
                label: "Lease Description",
                value: (
                  <LoadingOrValue
                    loading={!resident && isLoading}
                    value={resident.lease!.description!}
                    height={28}
                    width={150}
                  />
                ),
              },
            ]
          : []),
        ...(resident?.policyholderLocator
          ? [
              {
                label: "Covertree Policyholder Locator",
                value: (
                  <LoadingOrValue
                    loading={!resident && isLoading}
                    value={resident?.policyholderLocator ?? "N/A"}
                    height={28}
                    width={150}
                  />
                ),
              },
            ]
          : []),
        {
          label: "Lease Liability Insurance Limit",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.leaseRequirements.leaseLimit
                  ? formatCurrency(resident?.leaseRequirements.leaseLimit)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Lease Medical Payments Limit",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.leaseRequirements.medicalPaymentsLimit
                  ? formatCurrency(
                      resident?.leaseRequirements.medicalPaymentsLimit
                    )
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Lease Animal Liability Limit",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.leaseRequirements.animalLiabilityLimit
                  ? formatCurrency(
                      resident?.leaseRequirements.animalLiabilityLimit
                    )
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Has Resident opted into BRL?",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.wasOptedIn ? "Yes" : "No"}
              height={28}
              width={150}
            />
          ),
        },
        {
          label: "Is NARI workflow applicable?",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={resident?.isNariWorkflowApplicable ? "Yes" : "No"}
              height={28}
              width={150}
            />
          ),
        },
      ]}
    />
  );
}
